// extracted by mini-css-extract-plugin
export var col = "Field__col-X7KtA";
export var primary = "Field__primary-GRvTN";
export var secondary = "Field__secondary-m9s+X";
export var wrapper = "Field__wrapper-InPEs";